module.exports = __webpack_public_path__ + "img/tick.6b196a14.gif";